import React from 'react';
import {Route, Navigate, useLocation} from "react-router-dom"

import { useAuth } from '../../contexts/authContext';

export default function PrivateRoute({component: Component, ...rest}) {
  const {currentUser} = useAuth()

  function RequireAuth({ children }) {
    let location = useLocation();

    if (!currentUser) {
      // Redirect them to the /login page, but save the current location they were
      // trying to go to when they were redirected. This allows us to send them
      // along to that page after they login, which is a nicer user experience
      // than dropping them off on the home page.
      return <Navigate to="/login" state={{ from: location }} />;
    }

    return children;
  }

  return (
    // <Route {...rest} render={(props) => {
    //   return currentUser ? <Component {...props} /> : <Navigate to="/login" />
    // }}>

    // </Route>

    // <Route
    //   {...rest}
    //   element={(props) => {
    //     return <RequireAuth><Component {...props} /></RequireAuth>
    //   }}
    // />

    <RequireAuth><Component /></RequireAuth>
  )
}
